function getEnterSide(event, element) {
  const rect = element.getBoundingClientRect();
  const elementCenterX = rect.left + rect.width / 2;

  return event.clientX < elementCenterX ? 'left' : 'right';
}

export default function ClassHandler() {
	const elements = document.querySelectorAll('[data-class]');

	if (elements) {
		elements.forEach((el) => {
			el.addEventListener('click', () => {
				const openElement = document.querySelector('[data-class].open');
				
				if (openElement) openElement.classList.remove('open');
				if (openElement !== el) el.classList.toggle('open');
			});
		});
	}
}
